module.exports = "<div class=\"\" data-bind=\"visible: visible, attr: {'component_name':componentName, 'id': id}\">\n    <div class=\"row\">\n        <div class=\"col-sm-12\">\n            <p class=\"text-center\">The Job Description Manager includes information from the O*NET&trade; 21.0 database.</p>\n            <p class=\"text-center\">O*NET&trade; is a trademark of the U.S. Department of Labor, Employment and Training Administration.</p>\n        </div>\n    </div>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/components/footer/footer.html
// module id = 646
// module chunks = 0